var map = {
	"./AccountingControlCenter": [
		3485,
		9,
		[
			3485
		]
	],
	"./AccountingControlCenter.js": [
		3485,
		9,
		[
			3485
		]
	],
	"./Auth": [
		4905,
		9,
		[]
	],
	"./Auth.js": [
		4905,
		9,
		[]
	],
	"./Auth.js.bak_final_v2_20260813-040240": [
		9496,
		1,
		[
			9496
		]
	],
	"./B2BModule": [
		6003,
		9,
		[
			6003
		]
	],
	"./B2BModule.js": [
		6003,
		9,
		[
			6003
		]
	],
	"./B2BModule.js.bak_google_places_20260813-030855": [
		6348,
		1,
		[
			6348
		]
	],
	"./BarcodeSettings": [
		7349,
		9,
		[
			7349
		]
	],
	"./BarcodeSettings.js": [
		7349,
		9,
		[
			7349
		]
	],
	"./BatchTraceability": [
		6339,
		9,
		[
			6339
		]
	],
	"./BatchTraceability.js": [
		6339,
		9,
		[
			6339
		]
	],
	"./BusinessExpenses": [
		3920,
		9,
		[
			3920
		]
	],
	"./BusinessExpenses.js": [
		3920,
		9,
		[
			3920
		]
	],
	"./Chat": [
		6557,
		9,
		[
			1071,
			4195,
			6557
		]
	],
	"./Chat.js": [
		6557,
		9,
		[
			1071,
			4195,
			6557
		]
	],
	"./CompanySettings": [
		345,
		9,
		[
			345
		]
	],
	"./CompanySettings.js": [
		345,
		9,
		[
			345
		]
	],
	"./CompletedTasks": [
		4294,
		9,
		[
			1071,
			2377,
			4294
		]
	],
	"./CompletedTasks.js": [
		4294,
		9,
		[
			1071,
			2377,
			4294
		]
	],
	"./CoreProductConversion": [
		4533,
		9,
		[
			4533
		]
	],
	"./CoreProductConversion.js": [
		4533,
		9,
		[
			4533
		]
	],
	"./Dashboard": [
		7479,
		9,
		[
			2377,
			7479
		]
	],
	"./Dashboard.js": [
		7479,
		9,
		[
			2377,
			7479
		]
	],
	"./Dashboard.js.bak_overdue_calendar_": [
		9145,
		1,
		[
			9145
		]
	],
	"./Dashboard.js.bak_recurrence_dashboard_v2": [
		9291,
		1,
		[
			9291
		]
	],
	"./Dashboard.js.bak_v2_20260813-012518": [
		8736,
		1,
		[
			8736
		]
	],
	"./DashboardPage": [
		8040,
		9,
		[
			2377,
			8040
		]
	],
	"./DashboardPage.js": [
		8040,
		9,
		[
			2377,
			8040
		]
	],
	"./Documentation": [
		3233,
		9,
		[
			3233
		]
	],
	"./Documentation.js": [
		3233,
		9,
		[
			3233
		]
	],
	"./Documents": [
		8615,
		9,
		[
			8615
		]
	],
	"./Documents.js": [
		8615,
		9,
		[
			8615
		]
	],
	"./Documents.js.bak_documents_v3_20260813-041237": [
		7324,
		1,
		[
			7324
		]
	],
	"./Documents.js.bak_documents_v4_20260813-041808": [
		7711,
		1,
		[
			7711
		]
	],
	"./Documents.js.bak_final_v2_20260813-040240": [
		6138,
		1,
		[
			6138
		]
	],
	"./Documents.js.bak_preview_syntax_fix_": [
		2030,
		1,
		[
			2030
		]
	],
	"./EmployeeAdvances": [
		3236,
		9,
		[
			3236
		]
	],
	"./EmployeeAdvances.js": [
		3236,
		9,
		[
			3236
		]
	],
	"./EmployeeExtraPayments": [
		2850,
		9,
		[
			2850
		]
	],
	"./EmployeeExtraPayments.js": [
		2850,
		9,
		[
			2850
		]
	],
	"./EmployeeModule": [
		2967,
		9,
		[
			2967
		]
	],
	"./EmployeeModule.js": [
		2967,
		9,
		[
			2967
		]
	],
	"./EmployeePayrollWithAdvances": [
		6393,
		9,
		[
			6393
		]
	],
	"./EmployeePayrollWithAdvances.js": [
		6393,
		9,
		[
			6393
		]
	],
	"./FinancialArchive": [
		2272,
		9,
		[
			4238,
			2543,
			2272
		]
	],
	"./FinancialArchive.js": [
		2272,
		9,
		[
			4238,
			2543,
			2272
		]
	],
	"./FixedAssets": [
		4681,
		9,
		[
			4681
		]
	],
	"./FixedAssets.js": [
		4681,
		9,
		[
			4681
		]
	],
	"./FixedAssets.js.bak_category_costfix_v2_20260813-180942": [
		9072,
		1,
		[
			9072
		]
	],
	"./Layout": [
		1224,
		9,
		[]
	],
	"./Layout.js": [
		1224,
		9,
		[]
	],
	"./Layout.js.bak_b2b_20260813-023810": [
		9561,
		1,
		[
			9561
		]
	],
	"./Layout.js.bak_business_expenses_2026-08-12_23-33-40": [
		1239,
		1,
		[
			1239
		]
	],
	"./Layout.js.bak_business_menu_fix": [
		2797,
		1,
		[
			2797
		]
	],
	"./Layout.js.bak_depo_v1_20260813-004317": [
		3454,
		1,
		[
			3454
		]
	],
	"./Layout.js.bak_document_v1_20260813-035246": [
		6086,
		1,
		[
			6086
		]
	],
	"./Layout.js.bak_dropdown_2026-08-08_05-47-37": [
		474,
		1,
		[
			474
		]
	],
	"./Layout.js.bak_fixed_assets_v1_20260813-154111": [
		7644,
		1,
		[
			7644
		]
	],
	"./Layout.js.bak_mobile_b2b_v6_20260813-032611": [
		7650,
		1,
		[
			7650
		]
	],
	"./Layout.js.bak_price_lists_2026-08-08_13-05-21": [
		3268,
		1,
		[
			3268
		]
	],
	"./Layout.js.bak_product_cost_2026-08-08_05-34-42": [
		8432,
		1,
		[
			8432
		]
	],
	"./Layout.js.bak_profit_2026-08-08_04-50-05": [
		7393,
		1,
		[
			7393
		]
	],
	"./Layout.js.bak_shipping_v6_2026-08-12_18-22-49": [
		6577,
		1,
		[
			6577
		]
	],
	"./Layout.js.bak_sidebar_v3_2026-08-13_01-36-09": [
		108,
		1,
		[
			108
		]
	],
	"./Layout.js.phase26_icon_backup_20260818_003837": [
		2936,
		1,
		[
			2936
		]
	],
	"./MarketplacePriceModule": [
		5564,
		9,
		[
			5564
		]
	],
	"./MarketplacePriceModule.js": [
		5564,
		9,
		[
			5564
		]
	],
	"./NewOrder": [
		5821,
		9,
		[
			5821
		]
	],
	"./NewOrder.js": [
		5821,
		9,
		[
			5821
		]
	],
	"./Notifications": [
		9511,
		9,
		[
			1071,
			9511
		]
	],
	"./Notifications.js": [
		9511,
		9,
		[
			1071,
			9511
		]
	],
	"./Orders": [
		8054,
		9,
		[
			1071,
			8054
		]
	],
	"./Orders.js": [
		8054,
		9,
		[
			1071,
			8054
		]
	],
	"./OtherCosts": [
		427,
		9,
		[
			427
		]
	],
	"./OtherCosts.js": [
		427,
		9,
		[
			427
		]
	],
	"./OtherCosts.js.bak_category_v7_2026-08-12_20-38-45": [
		726,
		1,
		[
			726
		]
	],
	"./OtherCosts.js.bak_mobile_v13_20260812_231617": [
		5375,
		1,
		[
			5375
		]
	],
	"./OtherCosts.js.bak_shipping_v6_2026-08-12_18-22-49": [
		2407,
		1,
		[
			2407
		]
	],
	"./PriceLists": [
		8786,
		9,
		[
			6405
		]
	],
	"./PriceLists.js": [
		8786,
		9,
		[
			6405
		]
	],
	"./PriceLists.js.bak_price_lists_v2_2026-08-08_13-37-24": [
		471,
		1,
		[
			471
		]
	],
	"./PriceLists.js.bak_v10_2026-08-12_22-17-45": [
		6994,
		1,
		[
			6994
		]
	],
	"./PriceLists.js.bak_v3_2026-08-08_13-59-27": [
		5249,
		1,
		[
			5249
		]
	],
	"./PriceLists.js.bak_v4_2026-08-08_14-09-32": [
		5818,
		1,
		[
			5818
		]
	],
	"./PriceLists.js.bak_v4_2026-08-08_14-11-42": [
		8538,
		1,
		[
			8538
		]
	],
	"./PriceLists.js.bak_v8_2026-08-12_21-40-16": [
		8688,
		1,
		[
			8688
		]
	],
	"./PriceLists.js.bak_v8_2026-08-12_21-43-51": [
		9702,
		1,
		[
			9702
		]
	],
	"./ProductCosts": [
		2712,
		9,
		[
			2712
		]
	],
	"./ProductCosts.js": [
		2712,
		9,
		[
			2712
		]
	],
	"./ProductCosts.js.bak_category_cards_2026-08-12_21-58-30": [
		3968,
		1,
		[
			3968
		]
	],
	"./ProductCosts.js.bak_category_costfix_v2_20260813-180942": [
		3478,
		1,
		[
			3478
		]
	],
	"./ProductCosts.js.bak_category_v7_2026-08-12_20-38-45": [
		1589,
		1,
		[
			1589
		]
	],
	"./ProductCosts.js.bak_cost_category_ui_v3_20260813-183118": [
		3021,
		1,
		[
			3021
		]
	],
	"./ProductCosts.js.bak_duplicate_edit_2026-08-12_22-32-40": [
		6288,
		1,
		[
			6288
		]
	],
	"./ProductCosts.js.bak_mobile_v13_20260812_231617": [
		9030,
		1,
		[
			9030
		]
	],
	"./ProductCosts.js.bak_shipping_v6_2026-08-12_18-22-49": [
		492,
		1,
		[
			492
		]
	],
	"./ProductCosts.js.bak_v8_2026-08-12_21-40-16": [
		4123,
		1,
		[
			4123
		]
	],
	"./ProductCosts.js.bak_v8_2026-08-12_21-43-51": [
		2769,
		1,
		[
			2769
		]
	],
	"./ProductCosts.js.bak_v8_jsxfix_": [
		2108,
		1,
		[
			2108
		]
	],
	"./ProductManagement": [
		7911,
		9,
		[
			1071,
			7911
		]
	],
	"./ProductManagement.js": [
		7911,
		9,
		[
			1071,
			7911
		]
	],
	"./ProductManagement.js.bak_category_v7_2026-08-12_20-38-45": [
		980,
		1,
		[
			980
		]
	],
	"./ProductManagement.js.bak_mobile_v13_20260812_231617": [
		3881,
		1,
		[
			3881
		]
	],
	"./ProductionEfficiency": [
		6135,
		9,
		[
			6135
		]
	],
	"./ProductionEfficiency.js": [
		6135,
		9,
		[
			6135
		]
	],
	"./Profile": [
		290,
		9,
		[
			290
		]
	],
	"./Profile.js": [
		290,
		9,
		[
			290
		]
	],
	"./ProfitCalculator": [
		4390,
		9,
		[
			4390
		]
	],
	"./ProfitCalculator.js": [
		4390,
		9,
		[
			4390
		]
	],
	"./ProfitLoss": [
		5017,
		9,
		[
			5017
		]
	],
	"./ProfitLoss.js": [
		5017,
		9,
		[
			5017
		]
	],
	"./ResetPassword": [
		5869,
		9,
		[]
	],
	"./ResetPassword.js": [
		5869,
		9,
		[]
	],
	"./ReturnManagement": [
		2874,
		9,
		[
			2874
		]
	],
	"./ReturnManagement.js": [
		2874,
		9,
		[
			2874
		]
	],
	"./ShippingCosts": [
		955,
		9,
		[
			955
		]
	],
	"./ShippingCosts.js": [
		955,
		9,
		[
			955
		]
	],
	"./ShippingCosts.js.bak_mobile_v13_20260812_231617": [
		8757,
		1,
		[
			8757
		]
	],
	"./ShippingReports": [
		502,
		9,
		[
			502
		]
	],
	"./ShippingReports.js": [
		502,
		9,
		[
			502
		]
	],
	"./StandardCutPatterns": [
		7427,
		9,
		[
			7427
		]
	],
	"./StandardCutPatterns.js": [
		7427,
		9,
		[
			7427
		]
	],
	"./StockCount": [
		501,
		9,
		[
			501
		]
	],
	"./StockCount.js": [
		501,
		9,
		[
			501
		]
	],
	"./StockMovements": [
		4180,
		9,
		[
			4180
		]
	],
	"./StockMovements.js": [
		4180,
		9,
		[
			4180
		]
	],
	"./StockMovements.js.bak_depo_barkod_v4_20260813-015753": [
		8497,
		1,
		[
			8497
		]
	],
	"./StockMovements.js.bak_ios_camera_v6_20260813-032611": [
		2918,
		1,
		[
			2918
		]
	],
	"./StockMovements.js.bak_phone_scanner_v5_20260813-020750": [
		876,
		1,
		[
			876
		]
	],
	"./Suppliers": [
		7502,
		9,
		[
			1071,
			7502
		]
	],
	"./Suppliers.js": [
		7502,
		9,
		[
			1071,
			7502
		]
	],
	"./Suppliers.js.bak_mobile_v13_20260812_231617": [
		9470,
		1,
		[
			9470
		]
	],
	"./TaskReports": [
		4771,
		9,
		[
			4238,
			4771
		]
	],
	"./TaskReports.js": [
		4771,
		9,
		[
			4238,
			4771
		]
	],
	"./Tasks": [
		1116,
		9,
		[
			1071,
			2377,
			4195,
			1116
		]
	],
	"./Tasks.js": [
		1116,
		9,
		[
			1071,
			2377,
			4195,
			1116
		]
	],
	"./Tasks.js.bak_recurrence_dashboard_v2": [
		3705,
		1,
		[
			3705
		]
	],
	"./UsageGuidePro": [
		1586,
		9,
		[
			1586
		]
	],
	"./UsageGuidePro.js": [
		1586,
		9,
		[
			1586
		]
	],
	"./Users": [
		1176,
		9,
		[
			1071,
			4195,
			1176
		]
	],
	"./Users.js": [
		1176,
		9,
		[
			1071,
			4195,
			1176
		]
	],
	"./Users.js.bak_final_v2_20260813-040240": [
		9324,
		1,
		[
			9324
		]
	],
	"./WarehouseReceiving": [
		2652,
		9,
		[
			2652
		]
	],
	"./WarehouseReceiving.js": [
		2652,
		9,
		[
			2652
		]
	],
	"./WarehouseRecipes": [
		375,
		9,
		[
			375
		]
	],
	"./WarehouseRecipes.js": [
		375,
		9,
		[
			375
		]
	],
	"./WarehouseRecipes.js.bak_remove_core_requirement_20260915-224319": [
		6965,
		1,
		[
			6965
		]
	],
	"./WarehouseReports": [
		1524,
		9,
		[
			1524
		]
	],
	"./WarehouseReports.js": [
		1524,
		9,
		[
			1524
		]
	],
	"./WarehouseStock": [
		9592,
		9,
		[
			9592
		]
	],
	"./WarehouseStock.js": [
		9592,
		9,
		[
			9592
		]
	],
	"./WarehouseStock.js.bak_category_costfix_v2_20260813-180942": [
		7794,
		1,
		[
			7794
		]
	],
	"./WarehouseStock.js.bak_depo_barkod_v4_20260813-015753": [
		8539,
		1,
		[
			920
		]
	],
	"./WarehouseStock.js.bak_fixed_assets_v1_20260813-154111": [
		3033,
		1,
		[
			3033
		]
	],
	"./WarehouseStockPage": [
		991,
		9,
		[
			9592,
			991
		]
	],
	"./WarehouseStockPage.css": [
		380,
		9,
		[
			380
		]
	],
	"./WarehouseStockPage.js": [
		991,
		9,
		[
			9592,
			991
		]
	],
	"./WholesaleQuickQuote": [
		6483,
		9,
		[
			6483
		]
	],
	"./WholesaleQuickQuote.js": [
		6483,
		9,
		[
			6483
		]
	],
	"./WholesaleScenarioPrices": [
		7459,
		9,
		[
			7459
		]
	],
	"./WholesaleScenarioPrices.js": [
		7459,
		9,
		[
			7459
		]
	],
	"./WholesaleScenarioPrices.js.bak_mobile_v13_20260812_231617": [
		1661,
		1,
		[
			1661
		]
	],
	"./WholesaleScenarioPrices.js.bak_v10_2026-08-12_22-17-45": [
		6390,
		1,
		[
			6390
		]
	],
	"./WholesaleScenarioPrices.js.bak_v8_2026-08-12_21-40-16": [
		8135,
		1,
		[
			516
		]
	],
	"./WholesaleScenarioPrices.js.bak_v8_2026-08-12_21-43-51": [
		3770,
		1,
		[
			3770
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[2].map(__webpack_require__.e)).then(() => (__webpack_require__.t(id, ids[1] | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5605;
module.exports = webpackAsyncContext;